/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react'
import { Analytics } from '@vercel/analytics/react'
import ScrollProvider from './src/contexts/ScrollContext'
import GuidelineProvider from './src/contexts/GuidelineContext'
import PopupProvider from './src/contexts/PopupContext'
import OverlayProvider from './src/contexts/OverlayContext'
import HealthPointServiceProvider from './src/contexts/HealthPointServiceContext'
import UnsupportedBrowserMessage from './src/components/common/UnsupportedBrowserMessage'
import GlobalInfoBanners from './src/components/common/GlobalInfoBanners'
import { navigate } from 'gatsby'
// import "core-js/stable";
// import "regenerator-runtime/runtime";
// import 'formdata-polyfill'

export const onRouteUpdate = ({ location, prevLocation }) => {
    const bareDomains = (process.env.GATSBY_BARE_DOMAINS || 'starship.org.nz').split(',')
    const isBareDomain = bareDomains.includes(location.hostname)
    const hasRedirect = location?.search?.includes('redirect=true')
    const prevHadRedirect = prevLocation?.search?.includes('redirect=true')
    const redirectDismissed = typeof window !== 'undefined'
        && window.__redirectBannerDismissed === true

    // On a bare domain, always ensure redirect=true is present in the URL.
    // On route change, carry redirect=true forward from the previous location,
    // unless the user has already dismissed the redirect banner.
    const shouldAddRedirect = !hasRedirect
        && (isBareDomain || (prevHadRedirect && !redirectDismissed))

    if (shouldAddRedirect) {
        const separator = location.search ? '&' : '?'
        const newUrl = `${location.pathname}${location.search}${separator}redirect=true${location.hash || ''}`
        navigate(newUrl, { replace: true })
    }
}

export const onClientEntry = () => {
    if (typeof window === 'undefined') return

    // Ensure gtag is available
    window.dataLayer = window.dataLayer || []
    function gtag() {
        window.dataLayer.push(arguments)
    }
    window.gtag = gtag

    // Bare-domain redirect — must run before React hydration
    const bareDomains = (process.env.GATSBY_BARE_DOMAINS || 'starship.org.nz').split(',')
    const { hostname, protocol, pathname, search, hash } = window.location
    if (bareDomains.includes(hostname) && !search.includes('redirect=true')) {
        var wwwHost = ''
        if (hostname === 'localhost') {
            wwwHost = 'localhost:8000'
        } else if (hostname === 'starship.org.nz') {
            wwwHost = 'www.starship.org.nz'
        } else {
            wwwHost = hostname
        }
        const separator = search ? '&' : '?'
        const redirectUrl = `${protocol}//${wwwHost}${pathname}${search}${separator}redirect=true${hash || ''}`

        window.newrelic?.setCustomAttribute('BareDomainNavigation', 'bare', true)
        // replace() prevents back-button loop; the page load is aborted so
        // React never mounts — zero flash, zero double-render.
        window.location.replace(redirectUrl)
        return
    }

    window.newrelic?.setCustomAttribute('BareDomainNavigation', 'www', true)
}

export const wrapRootElement = ({ element }) => {
    return (
        <OverlayProvider>
            <PopupProvider>
                <GuidelineProvider>
                    <HealthPointServiceProvider>
                        <ScrollProvider>
                            {process.env.GATSBY_CONTENTFUL_ENVIRONMENT === 'master' && <Analytics />}
                            <UnsupportedBrowserMessage />
                            <GlobalInfoBanners />
                            {element}
                        </ScrollProvider>
                    </HealthPointServiceProvider>
                </GuidelineProvider>
            </PopupProvider>
        </OverlayProvider>
    )
}
